import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function How() {
  const { t } = useI18n();
  const steps = t('how.steps');
  return (
    <section className="how-section">
      <div className="how-inner">
        <span className="section-tag">{t('how.tag')}</span>
        <h2 className="section-title">{t('how.title')}</h2>
        <p className="section-sub" style={{ marginBottom: 0 }}>{t('how.sub')}</p>
        <div className="steps-grid">
          {Array.isArray(steps) && steps.map((s, i) => (
            <div className="step" key={i}>
              <div className="step-num">{s.num}</div>
              <div className="step-bar"></div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}